var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"castle-list-item"},[_c('router-link',{staticClass:"_unlink",attrs:{"to":_vm.link}},[_c('div',{staticClass:"layout"},[_c('h2',[_vm._v(_vm._s(_vm.name))]),_c('p',[_vm._v(_vm._s(_vm.distanceRangeLabel))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }